import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../base";

function FeedbackTitlePreview({ ...props }) {
  return <BasePreview {...props}>
      <h1>You have already been unsubscribed.</h1>
  </BasePreview>
}

function FeedbackTitleHTML({ content, attributes }) {
  return <h1 {...attributes}>{content}</h1>
}

export default define('unsub-feedback-title', FeedbackTitlePreview, FeedbackTitleHTML)
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.typography())
  .property(prop.text('Content', 'content').category('default').own())
  .defaultProps({
    content: "You have {{#if alreadyUnsubscribed}}already {{/if}}been unsubscribed.",
    size: { width: 'w-full' },
    fontWeight: 'font-bold',
  })
  .build()
